export const environment = {
  production: false,
  apiUrl: 'https://overwatch-dev-api.crio-server.com/api/admin',
  locale: 'en',
  fallbackLocale: 'en',
};
